'use client';

import { type FC, type PropsWithChildren } from 'react';

import { useMode } from '@shared/hooks';

import { type AnalyticsEvent } from '../config';
import { useAnalyticsInit } from '../hooks';
import {
  AnalyticsContext,
  type AnalyticsProvider as TProvider,
} from '../model';

type Props = PropsWithChildren<{
  providers: TProvider[];
}>;

const AnalyticsProvider: FC<Props> = ({ children, providers }) => {
  const { isProd } = useMode();

  useAnalyticsInit(providers.map((item) => item.id));

  const track = (event: AnalyticsEvent) => {
    if (!isProd) return;
    providers.forEach((p) => p.track(event));
  };

  const identify = (userGroupId: string) => {
    if (!isProd) return;
    providers.forEach((p) => p.identify?.(userGroupId));
  };

  return (
    <>
      {isProd && providers.map((provider) => provider.getScript?.() ?? null)}

      <AnalyticsContext.Provider value={{ track, identify }}>
        {children}
      </AnalyticsContext.Provider>
    </>
  );
};

export default AnalyticsProvider;
